import { useState } from "react";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { showQuestionDeleteAlert, showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";
import { axiosEduServer } from "../../../utils/configAxios";

export const CierreGestionPage = () => {
  const [anio, setAnio] = useState(new Date().getFullYear() - 1);
  const [loading, setLoading] = useState(false);

  const handleArchivar = async () => {
    showQuestionDeleteAlert({
      title: `¿Archivar Gestión ${anio}?`,
      text: `Esta acción ocultará a más de 2000 registros (estudiantes y grupos) de las listas activas. Esta es una acción administrativa masiva.`,
      callback: async (result) => {
        if (!result.isConfirmed) return;

        try {
          setLoading(true);
          const response = await axiosEduServer.post("/mantenimiento/archivar-gestion", { anio: parseInt(anio) });
          
          showAlert({
            text: response.data.message || "Gestión archivada correctamente.",
          });
        } catch (error) {
          console.error("Error al archivar gestión:", error);
          showErrorAlert({
            text: error.response?.data?.message || "Ocurrió un error al procesar el cierre de gestión.",
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <ContenedorPageTemplate titulo="Mantenimiento de Sistema">
      <div className="max-w-4xl mx-auto mt-8 p-8 bg-white rounded-2xl shadow-xl border border-gray-100">
        <div className="flex items-center gap-4 mb-8">
          <div className="p-3 bg-blue-100 rounded-lg text-blue-600">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Cierre de Gestión</h2>
            <p className="text-gray-500">Archiva registros antiguos para optimizar el rendimiento y limpiar las listas activas.</p>
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-amber-50 border-l-4 border-amber-400 p-4 rounded-r-lg">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-amber-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-amber-800">Advertencia de Acción Masiva</h3>
                <div className="mt-2 text-sm text-amber-700">
                  <p>Al archivar una gestión, todos los estudiantes y grupos asociados a ese año serán marcados como "Deshabilitados". No aparecerán en las listas de asistencia, reprobados o activos, pero los datos permanecerán en la base de datos.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-700 uppercase tracking-wider">Seleccionar Año a Archivar</label>
            <div className="flex gap-4">
              <input
                type="number"
                value={anio}
                onChange={(e) => setAnio(e.target.value)}
                className="w-32 border border-gray-300 rounded-lg py-3 px-4 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                min="2020"
                max={new Date().getFullYear()}
              />
              <button
                onClick={handleArchivar}
                disabled={loading}
                className={`flex-1 py-3 px-6 rounded-lg font-bold text-white transition shadow-lg ${
                  loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 active:transform active:scale-95"
                }`}
              >
                {loading ? (
                  <div className="flex items-center justify-center gap-2">
                    <div className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></div>
                    Procesando...
                  </div>
                ) : (
                  `Archivar Gestión ${anio}`
                )}
              </button>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-100 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="p-4 bg-gray-50 rounded-xl">
            <h4 className="font-bold text-gray-700 mb-2 italic">¿Qué sucede con los estudiantes?</h4>
            <ul className="text-sm text-gray-600 space-y-1 list-disc pl-4">
              <li>Se ocultan de la lista principal.</li>
              <li>Se ocultan de la lista de reprobados.</li>
              <li>Se ocultan de la lista de congelados.</li>
            </ul>
          </div>
          <div className="p-4 bg-gray-50 rounded-xl">
            <h4 className="font-bold text-gray-700 mb-2 italic">¿Qué sucede con los grupos?</h4>
            <ul className="text-sm text-gray-600 space-y-1 list-disc pl-4">
              <li>Se cierran las listas de asistencia.</li>
              <li>Se ocultan de la gestión de grupos activos.</li>
              <li>Se liberan visualmente los módulos.</li>
            </ul>
          </div>
        </div>
      </div>
    </ContenedorPageTemplate>
  );
};
